import {keys} from '@acng/frontend-bounty/object.js';
import {join} from '@acng/frontend-bounty/std/array.js';
import {parseInteger} from '@acng/frontend-bounty/std/number.js';
import {OPTIONAL, STRING, TUPLE, guard} from '@acng/frontend-rubicon';

export const make = (matchValue = '\\d+') => {
  /**
   * @type {Record<string, (x: number, y: number) => boolean>}
   */
  const compare = {
    '<=': (x, y) => x <= y,
    '>=': (x, y) => x >= y,
    '<': (x, y) => x < y,
    '>': (x, y) => x > y,
    '=': (x, y) => x === y,
  };

  const syntax = new RegExp(`^(${join(keys(compare), '|')})?\\s*(${matchValue})$`);

  /**
   * @param {string} str
   * @param {number} value
   * @returns {boolean}
   */
  return (str, value) => {
    const match = syntax.exec(str);
    ASSERT: guard(match, TUPLE(STRING, OPTIONAL(STRING), STRING), 'attribute compare syntax');

    const parsedValue = parseInteger(match[2]);
    const operator = match[1] ?? '>=';

    return compare[operator](value, parsedValue);
  };
};
